import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDevices: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDevices"><Path d="M19 17H16V19H19V17Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 3H3V15H1V21H12V22H23V8H21V3ZM12 17H3V19H12V17ZM14 20H21V10H14V20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDevices;
